export function setInfo(route) {
  switch (route) {
    case 'Device State':
      return {
        enabled: true,
        filtersDate: false,
        filtersDevice: false,
        filtersCycle: false,
        filtersDeviceState: true,
        filtersDeviceStateHistory: false,
        filtersActions: false,
        filtersCompact: true,
        filtersEdge: false,
        filtersInsights: false,
        filtersInsightsDesigner: false,
      }

    case 'Device State History':
      return {
        enabled: true,
        filtersDate: false,
        filtersDevice: false,
        filtersCycle: false,
        filtersDeviceState: false,
        filtersDeviceStateHistory: true,
        filtersActions: false,
        filtersCompact: false,
        filtersEdge: false,
        filtersInsights: false,
        filtersInsightsDesigner: false,
      }

    case 'Device State History Detail':
      return {
        enabled: true,
        filtersDate: true,
        filtersDevice: true,
        filtersCycle: false,
        filtersDeviceState: false,
        filtersDeviceStateHistory: false,
        filtersActions: false,
        filtersCompact: false,
        filtersEdge: false,
        filtersInsights: false,
        filtersInsightsDesigner: false,
      }

    case 'Insights':
      return {
        enabled: true,
        filtersInsights: true,
        filtersDevice: false,
        filtersInsightsDesigner: true,
        filtersDate: false,
        filtersCycle: false,
        filtersDeviceState: false,
        filtersDeviceStateHistory: false,
        filtersActions: false,
        filtersCompact: false,
        filtersEdge: false,
      }

    case 'Interact Activity':
      return {
        enabled: true,
        filtersDate: false,
        filtersDevice: false,
        filtersCycle: false,
        filtersDeviceState: false,
        filtersDeviceStateHistory: false,
        filtersActions: false,
        filtersCompact: false,
        filtersEdge: false,
        filtersInsights: false,
        filtersInsightsDesigner: false,
      }
    case 'Interact Cycle':
      return {
        enabled: true,
        filtersDate: false,
        filtersDevice: false,
        filtersCycle: false,
        filtersDeviceState: false,
        filtersDeviceStateHistory: false,
        filtersActions: false,
        filtersCompact: false,
        filtersEdge: false,
        filtersInsights: false,
        filtersInsightsDesigner: false,
      }
    case 'Actions':
      return {
        enabled: true,
        filtersDate: false,
        filtersDevice: false,
        filtersCycle: false,
        filtersDeviceState: false,
        filtersDeviceStateHistory: false,
        filtersActions: true,
        filtersCompact: false,
        filtersEdge: false,
        filtersInsights: false,
        details: false,
        filtersInsightsDesigner: false,
      }
    case 'Edge':
      return {
        enabled: true,
        filtersEdge: true,
        filtersDate: false,
        filtersDevice: false,
        filtersCycle: false,
        filtersDeviceState: false,
        filtersDeviceStateHistory: false,
        filtersActions: false,
        filtersCompact: false,
        filtersInsights: false,
        details: false,
        filtersInsightsDesigner: false,
      }

    default:
      return {
        enabled: false,
        filtersCompact: false,
        filtersEdge: false,
      }
  }
}
